<template>
    <div class="chat-questions" v-if="options">
        <span v-if="currentQuestion">
            {{ currentQuestion.message }}
        </span>

        <div class="chat-buttons-container" v-if="lastMessageQcmQuestion && lastMessageQcmQuestion?.length">
            <button v-for="(option, j) in options" :key="j" class="chat-buttons" :class="[(onSelected && currentQuestion.valid_answer == option.value) ? 'correct' :
        onSelected ? 'incorrect' : '']" style="white-space: normal !important;" @click="nextQuestion(option)"
                :disabled="disabled || onSelected">
                <i v-if="onSelected" class="material-icons check-done">
                    {{ (onSelected && currentQuestion.valid_answer == option.value) ? 'check_circle' : 'cancel' }}
                </i>
                <span>{{ $t(option.name) }}</span>
            </button>
        </div>
    </div>
</template>


<script>
import styleProfile from '../style-profile'
import utils from '../utils'
import { onBoxQcmResult } from '@/controller/qcm'
import { customLogger } from "@/utils";
const store_utils = require("@/store_utils").default;

export default {
    name: 'QcmQuestions',
    components: {
    },
    props: {
        step_value: {
            type: String,
            required: true
        },
        questions: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        live_coach: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentQestionIndex: 0,
            totalScore: 0,
            goNextStep: false,
            onSelected: false,
            correctAnswer: null
        }
    },
    mounted() {
        this.goNextStep = this.lastSelection
        this.scrollToBottom();
    },
    computed: {
        options() {
            if (this.lastMessageQcmQuestion?.length) {
                return this.lastMessageQcmQuestion[this.currentQestionIndex]?.buttons
            }
        },
        currentQuestion() {
            if (this.lastMessageQcmQuestion?.length) {
                return this.lastMessageQcmQuestion[this.currentQestionIndex]
            }
        },
        isLastQuestion() {
            return this.currentQestionIndex === this.lastMessageQcmQuestion?.length
        },
        numberOfQuestions() {
            return this.lastMessageQcmQuestion?.length || 0
        },
        qcmResultsKeys() {
            return this.$store.state.user?.data?.qcm_results ? Object.keys(this.$store.state.user.data.qcm_results) : [];
        },
        lastMessageQcmQuestion() {
            let questions = [];
            const length = this.$store.state.user.messages.length;
            const messages = this.$store.state.user.messages;

            if (this.disabled) {
                return this.questions
            }
            if (messages[length - 1] && messages[length - 1]?.content?.questions) {
                questions = messages[length - 1].content.questions;
            }
            return questions;
        },
        lastSelection() {
            let last = false
            if (this.qcmResultsKeys?.length && this.$store.state.config?.steps["start_quizz"]?.selection?.length) {
                last = this.qcmResultsKeys.length == this.$store.state.config?.steps["start_quizz"]?.selection.length - 2
            }
            return last
        },
    },
    updated() {
        this.scrollToBottom();
    },
    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                utils.scrollDown();
            });
        },
        async nextSection() {
            try {
                const cb = await onBoxQcmResult({
                    score: this.totalScore,
                    step: this.step_value,
                    numberOfQuestions: this.numberOfQuestions
                })
                if (cb.qcm_results) {
                    this.$store.commit('SET_DATA', cb)
                    customLogger(this.$store.state.user.data.qcm_results);
                    if (this.live_coach) {
                        this.$store.commit("SET_MODE", "chat");
                        const result = this.$store.state.user.data?.qcm_results?.live_coach_generate_questions;
                        if (result) {
                            store_utils.emit_message({
                                message: `Vous avez terminé le test Vous avez <strong>${result.score} sur ${result.numberOfQuestions}</strong> réponses correctes. 
                                Vous pouvez maintenant poser vos questions à notre coach en direct.`,
                                sender: "bot",
                                commit: true,
                                ignoreGpt: true,
                            });
                        }
                        return
                    }
                    if (this.goNextStep) {
                        styleProfile.generateNextStyleProfileStep("biens_ending1")
                    } else {
                        styleProfile.generateNextStyleProfileStep("start_quizz")
                    }
                }
            } catch (error) {
                customLogger('Error in nextSection', error)
            }
        },
        async nextQuestion({ name, value }) {
            this.onSelected = true
            setTimeout(() => {
                if (this.currentQuestion.valid_answer === value) {
                    this.totalScore++
                    this.correctAnswer = value
                }
                this.currentQestionIndex++
                this.onSelected = false
                if (this.isLastQuestion) {
                    this.nextSection()
                    return
                }
            }, 2500)
        },
    }

}
</script>